import React from 'react';
import { mockCase, mockDiscoverySets } from '../data/mockData';
export function CaseHeader() {
  const totalQuestions = mockDiscoverySets.reduce((acc, set) => acc + set.questionCount, 0);
  const totalResponses = mockDiscoverySets.reduce((acc, set) => acc + (set.questions?.length || 0), 0);
  const pendingSets = mockDiscoverySets.filter(set => set.status === 'Pending' || set.status === 'Overdue' || set.status === 'Partial').length;
  return <div className="bg-navy-surface border-b border-navy-border sticky top-0 z-10" data-id="element-6">
      <div className="px-6 py-4" data-id="element-7">
        <div className="flex justify-between items-start mb-3" data-id="element-8">
          <div data-id="element-9">
            <h1 className="text-lg font-semibold text-white tracking-tight mb-1" data-id="element-10">
              {mockCase.name}
            </h1>
            <div className="flex items-center gap-4 text-xs text-text-secondary" data-id="element-11">
              <span className="flex items-center gap-1" data-id="element-12">
                <span className="text-text-muted" data-id="element-13">Case No:</span>{' '}
                {mockCase.number}
              </span>
              <span className="text-navy-border" data-id="element-14">|</span>
              <span className="flex items-center gap-1" data-id="element-15">
                <span className="text-text-muted" data-id="element-16">Court:</span> {mockCase.court}
              </span>
              <span className="text-navy-border" data-id="element-17">|</span>
              <span className="flex items-center gap-1" data-id="element-18">
                <span className="text-text-muted" data-id="element-19">Judge:</span> {mockCase.judge}
              </span>
            </div>
          </div>
          <div className="bg-navy-elevated border border-navy-border rounded-sm px-3 py-1.5 text-xs text-text-secondary flex gap-4" data-id="element-20">
            <div className="flex flex-col items-center" data-id="element-21">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-22">
                Parties
              </span>
              <span className="font-semibold text-white" data-id="element-23">
                {mockCase.parties.length}
              </span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-24"></div>
            <div className="flex flex-col items-center" data-id="element-25">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-26">
                Sets
              </span>
              <span className="font-semibold text-white" data-id="element-27">
                {mockDiscoverySets.length}
              </span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-28"></div>
            <div className="flex flex-col items-center" data-id="element-29">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-30">
                Q's
              </span>
              <span className="font-semibold text-white" data-id="element-31">{totalQuestions}</span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-32"></div>
            <div className="flex flex-col items-center" data-id="element-33">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-34">
                Resp
              </span>
              <span className="font-semibold text-white" data-id="element-35">{totalResponses}</span>
            </div>
            <div className="w-px bg-navy-border" data-id="element-36"></div>
            <div className="flex flex-col items-center" data-id="element-37">
              <span className="text-text-muted text-xxs uppercase tracking-wider" data-id="element-38">
                Pending
              </span>
              <span className="font-semibold text-accent-amber" data-id="element-39">
                {pendingSets}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>;
}